export default __webpack_public_path__ + "static/media/necklace_dark.019a1669.png";